import React, { useCallback, useEffect, useState, useMemo } from "react";
import {
  Box,
  Chip,
  Grid,
  IconButton,
  Tooltip,
  Typography
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import Swal from "sweetalert2";
import {
  changeSopApplicationStatusAction,
  leadDocumentDeleteAction,
  leadTraveAndImmigrationFindingAction,
  leadTravelAndImmigrationUploadingAction
} from "../../../actions/leadActions/leadDocsActions";
import { findcountryMasterAddAction } from "../../../actions/countryMasterAction";
import { successTrueMsgAction } from "../../../actions/globalAction";
import CountryFlag from "../../customComponent/CountryFlag";
import { IoEyeOutline } from "react-icons/io5";
import { CiRepeat } from "react-icons/ci";
import { GoDownload } from "react-icons/go";
import { AiTwotoneDelete } from "react-icons/ai";

function TravelImmigration({ handleCompleteTick }) {
  const dispatch = useDispatch();
  const { id } = useParams();
  const [hoveredIcon, setHoveredIcon] = useState(null);
  const [statusVerify, setStatusVerify] = useState({});

  // Selectors
  const {
    countryFindSuccess,
    leadTravelImmigrationUploadingSuccess,
    leadTravelImmigrationFindingSuccess,
    leadDocumentDeleteSuccess,
    successAlertMsgSuccess
  } = useSelector((state) => ({
    countryFindSuccess: state.findcountryMasterAdd.countryFindSuccess,
    leadTravelImmigrationUploadingSuccess: 
      state.leadTravelAndImmigrationUploading.leadTravelAndImmigrationUploadingSuccess,
    leadTravelImmigrationFindingSuccess: 
      state.leadTraveAndImmigrationFinding.leadTravelAndImmigrationFindingSuccess,
    leadDocumentDeleteSuccess: state.leadDocumentDelete.leadDocumentDeleteSuccess,
    successAlertMsgSuccess: state.successTrueMsg.successAlertMsgSuccess
  }));

  const { leadSopStatusChangeSuccess } = useSelector((state) => state.changeSopApplicationStatus)

  console.log(50,leadTravelImmigrationFindingSuccess);
  console.log(51,leadSopStatusChangeSuccess);
  
  

  // Memoized country list calculation
  const countryList = useMemo(() => {
    if (countryFindSuccess && leadTravelImmigrationFindingSuccess) {
      return countryFindSuccess.filter(country => 
        !leadTravelImmigrationFindingSuccess.some(t => t.countryName === country.countryName)
      );
    }
    return [];
  }, [countryFindSuccess, leadTravelImmigrationFindingSuccess]);

  // Fetch initial data
  useEffect(() => {
    dispatch(findcountryMasterAddAction(id, "travel"));
    dispatch(leadTraveAndImmigrationFindingAction(id));
  }, [dispatch, id, leadTravelImmigrationUploadingSuccess, leadDocumentDeleteSuccess, leadSopStatusChangeSuccess]);

  // Success alerts
  useEffect(() => {
    if (leadTravelImmigrationUploadingSuccess && successAlertMsgSuccess) {
      Swal.fire({
        icon: "success",
        title: "Good job \u{1F44D}",
        text: "Travel Document Uploaded Successfully"
      });
      dispatch(successTrueMsgAction(false));
    }
  }, [leadTravelImmigrationUploadingSuccess, successAlertMsgSuccess, dispatch, leadSopStatusChangeSuccess]);

  // Handlers
  const handleDocChange = useCallback((event, countryId, countryName) => {
    const file = event.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onloadend = () => {
      dispatch(leadTravelAndImmigrationUploadingAction(
        reader.result, 
        countryId, 
        id, 
        countryName
      ));
      dispatch(successTrueMsgAction(true));
    };
    reader.readAsDataURL(file);
  }, [dispatch, id]);

  const toggleStatusVerify = useCallback((docId, value) => {
    console.log(100,docId);
    
    setStatusVerify(prev => ({ ...prev, [docId]: value }));
  }, []);

  const handleDeleteDocument = useCallback((docId) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!"
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(leadDocumentDeleteAction(docId, id, "travel&immigration"));
        Swal.fire("Deleted!", "Your file has been deleted.\u{1F44D}", "success");
      }
    });
  }, [dispatch, id]);

  const handleStatusChange = useCallback((leadId, countryId, status) => {
    dispatch(changeSopApplicationStatusAction(
      leadId, 
      countryId, 
      status, 
      "travelImmigration"
    ));
  }, [dispatch]);

  // Style configuration
  const iconStyle = {
    width: "22px",
    height: "22px",
    marginRight: "10px",
    transition: "color 0.3s ease"
  };

  const iconHoverStyle = { color: "red" };

  const handleMouseEnter = useCallback((icon) => setHoveredIcon(icon), []);
  const handleMouseLeave = useCallback(() => setHoveredIcon(null), []);

  // Render helpers
  const renderUploadBox = (data) => (
    <Box
      sx={{
        height: 82,
        bgcolor: "white",
        border: "1.5px dashed rgba(25, 118, 210, 0.5)",
        borderRadius: 1
      }}
    >
      <label
        htmlFor={`travel-file-${data.id}`}
        style={{ 
          margin: 15,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          cursor: "pointer"
        }}
      >
        <div style={{ display: "flex", alignItems: "center" }}>
          <CountryFlag
            countryCode={data.countryCode}
            component="stepper"
            width={39}
            height={39}
          />
          <Typography variant="body1" ml={1.25}>
            {data.countryName.split("(")[0]}
          </Typography>
        </div>
        <div style={{ display: "flex", alignItems: "center" }}>
          <img src="/menuIcons/uploadBlue.png" alt="upload" />
          <Typography color="primary" ml={1} fontFamily="Montserrat">
            Upload
          </Typography>
        </div>
      </label>
      <input
        type="file"
        accept=".pdf,.doc,.docx,.xlsx"
        id={`travel-file-${data.id}`}
        hidden
        onChange={(e) => handleDocChange(e, data.id, data.countryName)}
      />
    </Box>
  );

  const renderStatusChips = (travelData) => (
    <Box
      sx={{
        position: "absolute",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        backdropFilter: "blur(8px)",
        gap: 2,
        opacity: 0,
        transition: "opacity 0.3s",
        zIndex: 1,
        "&:hover": { opacity: 1 }
      }}
    >
      <Chip
        label="Reupload"
        color="warning"
        variant="outlined"
        sx={{ 
          borderColor: "warning.main",
          color: "warning.main",
          cursor: "pointer"
        }}
        onClick={() => {
          handleStatusChange(travelData.leadId, travelData.countryId, "reupload");
          toggleStatusVerify(travelData.id, false);
        }}
      />
      <Chip
        label="Verify"
        color="success"
        variant="outlined"
        sx={{
          borderColor: "success.main",
          color: "success.main",
          cursor: "pointer"
        }}
        onClick={() => {
          handleStatusChange(travelData.leadId, travelData.countryId, "verified");
          toggleStatusVerify(travelData.id, false);
        }}
      />
      <Chip
        label="Close"
        color="error"
        variant="outlined"
        sx={{ cursor: "pointer" }}
        onClick={() => toggleStatusVerify(travelData.id, false)}
      />
    </Box>
  );

  const renderActionIcons = (travelData) => (
    <>
      <a
        href={travelData.pdfUrl}
        download
        target="_blank"
        rel="noopener noreferrer"
        style={{ textDecoration: "none", color: "black" }}
      >
        <Tooltip title="View">
          <IconButton>
            <IoEyeOutline style={{
              ...iconStyle,
              color: hoveredIcon === "view" ? "red" : "black",
              cursor: "pointer"
            }}
              onMouseEnter={() => handleMouseEnter("view")}
              onMouseLeave={handleMouseLeave}
            />
          </IconButton>
        </Tooltip>
      </a>

      {travelData.status !== "approved" && (
        <Tooltip title="Change status">
          <IconButton
            sx={{ padding: 0, marginRight: "10px" }}
            onClick={() => toggleStatusVerify(travelData.id, true)}
          >
            <CiRepeat style={{
              ...iconStyle,
              color: hoveredIcon === "repeat" ? "red" : "black"
            }}
            onMouseEnter={() => handleMouseEnter("repeat")}
            onMouseLeave={handleMouseLeave}
             />
          </IconButton>
        </Tooltip>
      )}

      <a
        href={travelData.pdfUrl}
        download
        target="_blank"
        rel="noopener noreferrer"
        style={{ textDecoration: "none", color: "black" }}
      >
        <Tooltip title="Download">
          <IconButton>
            <GoDownload style={{
              ...iconStyle,
              color: hoveredIcon === "download" ? "red" : "black"
            }}
              onMouseEnter={() => handleMouseEnter("download")}
              onMouseLeave={handleMouseLeave}
            />
          </IconButton>
        </Tooltip>
      </a>

      {!["verified", "approved"].includes(travelData.status) && (
        <Tooltip title="Delete">
          <IconButton onClick={() => handleDeleteDocument(travelData.id)}>
            <AiTwotoneDelete style={{
              ...iconStyle,
              color: hoveredIcon === "delete" ? "red" : "black"
            }}
              onMouseEnter={() => handleMouseEnter("delete")}
              onMouseLeave={handleMouseLeave}
            />
          </IconButton>
        </Tooltip>
      )}
    </>
  );

  return (
    <Grid container spacing={2} p={1.25}>
      {countryList.length === 0 && leadTravelImmigrationFindingSuccess?.length === 0 && (
        <Typography
          variant="body1"
          textAlign="center"
          mt={10}
          fontFamily="Montserrat"
        >
          No documents to show. Add your preferred country or Add document in Knowledge bank
        </Typography>
      )}

      {countryList.map((data) => (
        <Grid item xs={6} md={4} lg={3} key={data.id}>
          <Box my={2}>{renderUploadBox(data)}</Box>
        </Grid>
      ))}

      {leadTravelImmigrationFindingSuccess?.map((travelData) => (
        <Grid item xs={6} md={4} lg={3} key={travelData.id}>
          <Box mt={1} mb={5} position="relative">
            <Box
              sx={{
                height: 82,
                bgcolor: "white",
                border: "1.5px dashed rgba(255, 153, 0, 1)",
                // theme => 
                //   ["verified", "approved"].includes(travelData.status)
                //     ? `1.5px dashed ${theme.palette.divider}`
                //     : "1.5px dashed rgba(255, 153, 0, 1)",
                borderRadius: 2
              }}
            >
              <Box display="flex" justifyContent="space-between" m={1.25}>
                <Box display="flex" alignItems="center">
                  <CountryFlag
                    countryCode={travelData.countryCode.countryCode}
                    component="stepper"
                    width={39}
                    height={39}
                  />
                  <Box ml={1.25}>
                    <Typography variant="body1">
                      {travelData.countryName.split("(")[0]}
                    </Typography>
                    <Box display="flex">
                      {!statusVerify[travelData.id] && renderActionIcons(travelData)}
                    </Box>
                  </Box>
                </Box>

                <Box display="flex" flexDirection="column" alignItems="flex-end">
                  <Typography color="success.main" fontFamily="Montserrat">
                    Uploaded
                  </Typography>
                  <Typography
                    color={["verified", "approved"].includes(travelData.status) 
                      ? "success.main" 
                      : "warning.main"}
                    textTransform="capitalize"
                  >
                    {travelData.status}
                  </Typography>
                </Box>
              </Box>
              {statusVerify[travelData.id] && renderStatusChips(travelData)}
            </Box>
          </Box>
        </Grid>
      ))}
    </Grid>
  );
}

export default React.memo(TravelImmigration);